import React from 'react';
import { Redirect } from 'react-router-dom';

interface Props {
    location: any;
}

export class RootController extends React.PureComponent<Props> {

    static globalUserID: string | null;

    render() {
        const search = this.props.location.search;
        const params = new URLSearchParams(search);

        RootController.globalUserID = params.get('id');

        return (<Redirect to='/setup?step=1' />);
    }
}
